<div class="link-container"
    *ngIf="!tabs">
    <a class="link-item"
        *ngFor="let link of links"
        [ngClass]="link.classlist || []"
        [attr.title]="link.title || ''"
        (click)="link.clickCallback && link.clickCallback(link, $event)"
        [attr.disabled]="link.disabled"
        [attr.href]="link.href || ''">
        <i [ngClass]="link.icon"
            *ngIf="link.icon"></i>
        <span class="link-label">{{link.label}}</span>
    </a>
</div>

<nav class="nav-bar"
    mat-tab-nav-bar
    [mat-stretch-tabs]="stretchTabs"
    [tabPanel]="tabPanel"
    [animationDuration]="animationDuration"
    [disablePagination]="true"
    *ngIf="tabs">
    <a class="mat-tab"
        *ngFor="let link of links"
        mat-tab-link
        [routerLink]="link.href"
        [queryParams]="link.queryParams || {}"
        [ngClass]="link.classlist || []"
        [class.active]="(link.href && link.isActive) || link.isActive"
        routerLinkActive
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: true}"
        [disabled]="link.disabled"
        [active]="(link.href && rla.isActive) || link.isActive"
        (click)="link.clickCallback && link.clickCallback(link, $event)"
        [attr.data-cy]="link.dataCy">
        <i [ngClass]="link.icon"
            *ngIf="link.icon"></i>
        <span class="link-label">{{link.label}}</span>
    </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>